@if(loader || ledgerLoading){
<app-loader></app-loader>
}
<p-card [header]="isEditMode ? 'Update Account' : 'Create Account'">
  <div class="account-tabs-wrapper">
    <div class="account-tab-toolbar flex justify-content-between align-items-center">
      <div class="flex gap-2">
        <p-button [label]="isEditMode ? 'Update' : 'Save'" icon="pi pi-save" size="small"
          (click)="saveUnitOfMeasure(createAccountForm.value, isEditMode)"></p-button>
        <p-button label="Cancel" icon="pi pi-times" size="small" (click)="Cancel()" severity="danger"
          class="p-button-sm"></p-button>
      </div>
      <label class="block label-required" style="font-weight: bold;">Required Field</label>
    </div>
    <ul class="account-tab-nav">
      <li [class.active]="activeIndex === 0" (click)="activeIndex = 0">Account Details</li>
      @if(isEditMode) {
      <li [class.active]="activeIndex === 1" (click)="activeIndex = 1">Recent Transactions</li>
      }
    </ul>

    @if(activeIndex === 0) {
    <div class="account-tab-panel">
      <form [formGroup]="createAccountForm">

        <div class="grid">
          <div class="col-4">
            <div class="field text-left">
              <label class="label-required display">Account Type</label>
              <p-autoComplete formControlName="accountType" (onSelect)="setUOM($event)" [forceSelection]="true"
                [dropdown]="isEditMode ? false : true" [readonly]="isEditMode" [disabled]="isEditMode"
                [suggestions]="filteruom" (completeMethod)="filterUOM($event)" field="accountType"
                placeholder="Search account types" class="w-full large-textbox" styleClass="w-full"
                [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.accountType.errors}"
                (keydown.enter)="focusNextInput($event)">
                <ng-template let-item pTemplate="item">
                  <span><span class="text-primary">{{item.accountTypeCode}}</span> - {{item.accountType}}</span>
                </ng-template>
              </p-autoComplete>
              <small *ngIf="submitted && formControls.accountType.hasError('required')" class="text-red-500">
                Required field.
              </small>
            </div>

            <div class="field text-left">
              <label class="label-required display">Account Name</label>
              <input pInputText placeholder="e.g Receivable" formControlName="accountName" (keydown)="onKeydown($event)"
                [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.accountName.errors}"
                class="w-full p-inputtext-sm" />
              <small *ngIf="submitted && formControls.accountName.errors" class="text-red-500">Required field.</small>
            </div>

            <div class="field text-left">
              <label for="ClosingBalance">Current Balance (₹)</label>
              <input pInputText class="w-full p-inputtext-sm text-right" readonly
                [ngModel]="displayCurrentBalance" [ngModelOptions]="{standalone: true}" />
              <small class="text-color-secondary">From posted GL: SUM(Debit − Credit)</small>
            </div>
          </div>

          <div class="col-4">

            <div class="field text-left">
              <label for="website" class="label-required display">Account Code</label>
              <div style="display: flex; align-items: center;">
                <input type="text" pattern="^[0-9@#\$%\^&\*\(\)\_\+\-=\[\]\{\};':|,.\/?]+$" pInputText
                  placeholder="ex. 85614" (keydown)="onKeydown($event)" style="width: 100%;" class="p-inputtext-sm"
                  formControlName="accountCode" [readonly]="isEditMode"
                  [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.accountCode.errors}" />
              </div>
              <small *ngIf="submitted && formControls.accountCode.hasError('required')" id="accountCode"
                class="text-red-500">
                Required field.
              </small>
            </div>


            <div class="field text-left">
              <label for="website" class="label-required display">Account Group</label>
              <div style="display: flex;">
                <p-autoComplete formControlName="accountGroupName" (onSelect)="setAccountGroup($event)" [dropdown]="true"
                  [suggestions]="filterAG" (completeMethod)="filterAGs($event)" field="accountGroupName"
                  placeholder="Search account groups" class="w-full" styleClass="w-full" [forceSelection]="true"
                  [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.accountGroupName.errors }"
                  (keydown.enter)="focusNextInput($event)">
                  <ng-template let-item pTemplate="item">
                    <span><span class="text-primary">{{item.accountGroupCode}}</span> - {{item.accountGroupName}}</span>
                  </ng-template>
                </p-autoComplete>

                <p-button (click)="createQuickAccountGroup(false)" [disabled]="products.length > 0"
                  class="p-button-outlined ml-2" icon="pi pi-user-plus" severity="info"></p-button>
              </div>
              <small *ngIf="submitted && formControls.accountGroupName.hasError('required')" id="accountGroupName"
                class="text-red-500" style="margin-top: -20px; display: block;">
                Required field.
              </small>
            </div>



            <div class="field text-left">
              <label for="website">Financial Statement</label>
              <input pInputText formControlName="financialStatement" (keydown)="onKeydown($event)"
                [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.financialStatement.errors }"
                class="w-full p-inputtext-sm" readonly />
              <small *ngIf="submitted && formControls.financialStatement.errors" id="financialStatement-error"
                class="text-red-500">Required field.</small>
            </div>

          </div>

          <div class="col-4">
            <div class="field text-left">
              <label for="website">Account Description</label>
              <textarea pInputText placeholder="e.g This account is regarding" class="w-full"
                formControlName="accountDescription" rows="4"
                [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.accountDescription.errors }"
                (keydown.enter)="focusNextInput($event)">
            </textarea>
            </div>


            <div class="field text-left">
              <label for="website">GL Comments</label>
              <textarea pInputTextarea formControlName="tags" rows="4" class="w-full" placeholder="Any comments..."
                (keydown)="onKeydown($event)"></textarea>
            </div>
          </div>
        </div>
      </form>
    </div>
    }

    @if(isEditMode && activeIndex === 1) {
    <div class="account-tab-panel">
      <div class="ledger-section mt-2">
        <div class="grid align-items-end mb-3">
          <div class="col-12 md:col-3">
            <label class="font-bold block mb-1">From Date</label>
            <p-calendar [(ngModel)]="ledgerFromDate" [ngModelOptions]="{standalone: true}" dateFormat="dd/mm/yy"
              [showIcon]="true" styleClass="w-full" placeholder="Opening before this date"></p-calendar>
          </div>
          <div class="col-12 md:col-3">
            <label class="font-bold block mb-1">To Date</label>
            <p-calendar [(ngModel)]="ledgerToDate" [ngModelOptions]="{standalone: true}" dateFormat="dd/mm/yy"
              [showIcon]="true" styleClass="w-full" placeholder="Optional"></p-calendar>
          </div>
          <div class="col-12 md:col-6 flex flex-wrap gap-2">
            <p-button label="Load Ledger" icon="pi pi-search" size="small" (click)="loadAccountLedger()"></p-button>
            <p-button label="Clear Filters" icon="pi pi-filter-slash" size="small" [outlined]="true"
              (click)="clearLedgerFilters()"></p-button>
            <p-button label="Refresh Balance" icon="pi pi-refresh" size="small" [outlined]="true"
              (click)="refreshAccountBalance()"></p-button>
          </div>
        </div>

        <div class="grid mb-3">
          <div class="col-12 md:col-4">
            <div class="ledger-summary-card">
              <span class="text-color-secondary">Opening Balance</span>
              <strong>{{ formatClosingBalance(ledgerOpeningBalance) }}</strong>
            </div>
          </div>
          <div class="col-12 md:col-4">
            <div class="ledger-summary-card">
              <span class="text-color-secondary">Closing Balance</span>
              <strong>{{ formatClosingBalance(ledgerClosingBalance) }}</strong>
            </div>
          </div>
          <div class="col-12 md:col-4">
            <div class="ledger-summary-card">
              <span class="text-color-secondary">Transactions</span>
              <strong>{{ ledgerLines.length }}</strong>
            </div>
          </div>
        </div>

        <p-table [value]="ledgerLines" styleClass="p-datatable-sm p-datatable-gridlines"
          [tableStyle]="{'min-width': '60rem'}" [paginator]="true" [rows]="10"
          [rowsPerPageOptions]="[10, 15, 20]" [showCurrentPageReport]="true"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} transactions">
          <ng-template pTemplate="header">
            <tr>
              <th>Date</th>
              <th>TransactionNo</th>
              <th>TransactionType</th>
              <th class="text-right">Debit (₹)</th>
              <th class="text-right">Credit (₹)</th>
              <th class="text-right">Balance (₹)</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr>
              <td>{{ row.transactionDate | date:'dd/MM/yyyy' }}</td>
              <td>{{ row.transactionNo }}</td>
              <td>{{ row.transactionType }}</td>
              <td class="text-right">{{ formatClosingBalance(row.debitAmount) }}</td>
              <td class="text-right">{{ formatClosingBalance(row.creditAmount) }}</td>
              <td class="text-right font-bold">{{ formatClosingBalance(row.runningBalance) }}</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="6" class="text-center text-color-secondary">No GL transactions found for this account.</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
    }
  </div>
</p-card>

<p-toast></p-toast>